import { createQueryKeys } from '@lukemorales/query-key-factory';
import { type MaybeRefOrGetter, toValue } from 'vue';

import { getSupportGrantedAccounts } from '../api/me';

export const accountKeys = createQueryKeys('accounts', {
  supportGranted: (name: MaybeRefOrGetter<string | undefined>) => ({
    queryKey: [name],
    queryFn: (options) => getSupportGrantedAccounts({ name: toValue(name) }, options),
  }),
});
